import { pathsV2Creators } from 'core/services/navigation/usePathsV2';
import { CandidateListTab } from 'modules/candidate-profile/stores/useCandidateListStore';
import { workflowBuilderLink } from 'modules/layout/constants/navbar';

export const embeddedCandidatesPath = pathsV2Creators.CANDIDATE_PROFILE_LIST({
  searchParams: { tab: CandidateListTab.CANDIDATES }
});

export type EmbeddedWorkflowsLink = {
  organizationId: string;
  instanceId: string;
  jobId: string | null;
};

export const buildEmbeddedWorkflowsUrl = ({
  organizationId,
  instanceId,
  jobId
}: EmbeddedWorkflowsLink): string => {
  const url = new URL('/ats', new URL(workflowBuilderLink).origin);
  url.searchParams.set('instanceId', instanceId);
  if (jobId) url.searchParams.set('jobId', jobId);
  url.searchParams.set('organizationId', organizationId);
  return url.toString();
};
